import { Link } from "react-router-dom";
import styled from "styled-components";

export const RowWrapper = styled.div<{ $justify?: "center" | "space-between" | 'flex-start' }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $justify = "center" }) => $justify};
  gap: 1rem;
  min-width: 0;
  flex: 1;
  overflow: visible;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;

export const ListItem = styled(Link)`
  color: ${({ theme }) => theme.palette.neutral.lightest};
  text-decoration: none;
  transition: color 0.3s ease;
  &:hover {
    color: ${({ theme }) => theme.palette.neutral.medium};
  }
`;

